export var NewYearGameCategoryType;
(function (NewYearGameCategoryType) {
    NewYearGameCategoryType[NewYearGameCategoryType["SPORT_LOTTERY"] = 1] = "SPORT_LOTTERY";
    NewYearGameCategoryType[NewYearGameCategoryType["LIVE_GAME"] = 2] = "LIVE_GAME";
    NewYearGameCategoryType[NewYearGameCategoryType["CARD_GAME"] = 4] = "CARD_GAME";
    NewYearGameCategoryType[NewYearGameCategoryType["VIDEO_GAME"] = 5] = "VIDEO_GAME";
    NewYearGameCategoryType[NewYearGameCategoryType["ESPORT"] = 7] = "ESPORT";
})(NewYearGameCategoryType || (NewYearGameCategoryType = {}));
export var NewYearType;
(function (NewYearType) {
    NewYearType["NEW_YEAR_2026"] = "new_year_2026";
})(NewYearType || (NewYearType = {}));
//# sourceMappingURL=NewYear.js.map